import { RootState } from '~/store';

export const getSocialMediaReducer = (state: RootState) => state.socialMediaReducer;
